
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packages",
      function () {
        return require("private-next-pages/packages/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packages"])
      });
    }
  